import React from 'react'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ProductCard from '../../components/ProductCard/ProductCard';
import useMixpanel from '../../hooks/useMixpanel';
import { useSelector } from 'react-redux';

export default function ProductsContent() {
    const history = useHistory();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const {trackP1Event} = useMixpanel();
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const handleClick = (direction, type) => {
        queryParams.set('direction', direction);
        queryParams.set('productsType', type);
        trackP1Event('onboarding_products', {
            web_product_type: direction
        })
        history.push({
            pathname: nextPage,
            search: `?${queryParams.toString()}`
        });
    };

    return (
        <>
            <ProductCard
                title={'Products'}
                img={'/img/WEBP_Type/Products.webp'}
                onClick={() => handleClick("PRODUCT", 'Products I buy or make myself')}
            />
            <ProductCard
                title={'Services'}
                img={'/img/WEBP_Type/Services.webp'}
                onClick={() => handleClick("SERVICE", 'Services')}
            />
            <ProductCard
                title={'Digital'}
                img={'/img/WEBP_Type/Digital.webp'}
                onClick={() => handleClick("PRODUCT", 'Digital products')}
            />
            <ProductCard
                title={'Dropshipping'}
                img={'/img/WEBP_Type/Dropshipping.webp'}
                onClick={() => handleClick("PRODUCT", 'Dropshipping products')}
            />
        </>
    )
}
